<div #splashScreen class="m-splash-screen">
    <img [attr.src]="splashScreenImage" style="width: 90px; margin-bottom: 30px;" alt="Logo">
</div>
